<ng-container *ngTemplateOutlet="(obsIsOldDisplaying.value$ | async) ? oldContent : content"></ng-container>

<ng-template #content>
	<ion-card [class]="((obsHasBorder.value$ | async) ? 'border-color' : '') + ' ion-text-center'"
		(click)="onClick(); $event.stopPropagation();">
		<ion-card-content>
			{{ obsValue.value$ | async }}
		</ion-card-content>
		<ion-card-header class="ion-text-center ion-no-padding">
			<ion-card-title [class]="'align-left justify-' + ((obsIcon.value$ | async) ? 'start' : 'center')">
				<ion-icon *ngIf="obsIcon.value$ | async as icon" [name]="icon"></ion-icon>
				<ion-label [class]="(obsIcon.value$ | async) ? 'label-with-icon' : ''">{{ obsTitle.value$ | async }}</ion-label>
			</ion-card-title>
		</ion-card-header>
	</ion-card>
</ng-template>

<!-- todo : supprimer ce template une fois la migration des merchs effectuée. -->
<ng-template #oldContent>
	<ion-card [class]="((obsHasBorder.value$ | async) ? 'border-color' : '') + ' ion-text-center'"
		(click)="onClick(); $event.stopPropagation();">
		<ion-card-content class="old-card-content">
			{{ obsValue.value$ | async }}
		</ion-card-content>
		<ion-card-header class="ion-text-center ion-no-padding">
			<ion-card-title class="old-card-title">
				<ion-icon *ngIf="(obsIcon.value$ | async) as icon" [name]="icon"></ion-icon>
				{{ obsTitle.value$ |async }}
			</ion-card-title>
			<ion-card-subtitle class="old-card-subtitle">
				{{ obsSubtitle.value$ | async }}
			</ion-card-subtitle>
		</ion-card-header>
	</ion-card>
</ng-template>